import ProductRow from '../AllProducts/ProductRow'
import SingleProduct from '../AllProducts/SingleProduct'
import { ContainerWrapper } from '../Container'
import SectionHeading from './SectionHeading'
import SectionHeadingWrapper from './SectionHeadingWrapper'

const cards = [
    {
        icon: '',
        title: 'Postcards for Every Investor',
        desc: 'Choose the right format to match your goals:',
        products: ['postcards'],
        background: false,
    },
]
function ProductCards({ products }) {
    return (
        <>
            <ContainerWrapper>
                <SectionHeadingWrapper>
                    <SectionHeading></SectionHeading>
                </SectionHeadingWrapper>

                <div>
                    {cards.map((card, i) => (
                        <ProductRow section={card} key={i}>
                            {products
                                .filter((product) =>
                                    card.products.includes(
                                        product.product.post_name,
                                    ),
                                )
                                .map(({ product, image, description }) => (
                                    <SingleProduct
                                        key={product.ID}
                                        {...{ product, image, description }}
                                    />
                                ))}
                        </ProductRow>
                    ))}
                </div>
            </ContainerWrapper>
        </>
    )
}

export default ProductCards
